import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isMobile, isTablet } from 'react-device-detect';
import posed from 'react-pose';
import styles from './magazineTrack.css';

const Track = posed.div({
  moveTrack: {
    x: ({ xPos }) => xPos,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 20,
    },
  },
});

class MagazineTrack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trackValue: 0,
    };
  }

  handleMouseMove = event => {
    const x = event.clientX;
    const windowWidth = window.innerWidth;
    const mouseXRatio = (x + 1) / windowWidth;
    const el = event.target.closest('ul');

    if (el && windowWidth > 600) {
      const trackWidth = el.offsetWidth - windowWidth;

      this.setState({
        trackValue: -trackWidth * mouseXRatio,
      });
    } else {
      this.setState({
        trackValue: 0,
      });
    }
  };

  render() {
    const {
      state: { trackValue },
      props: { children },
    } = this;

    return (
      <div
        onMouseMove={this.handleMouseMove}
        className={`${styles.wrapper} ${
          isMobile || isTablet ? styles.visible : ''
        }`}>
        <Track
          initialPose="moveTrack"
          pose="moveTrack"
          poseKey={trackValue}
          xPos={trackValue}>
          <ul className={styles.list}>
            {children.map(child => (
              <li key={child.props.title} className={styles.listItem}>
                <Link className={styles.link} to={child.props.path}>
                  {child}
                </Link>
              </li>
            ))}
          </ul>
        </Track>
      </div>
    );
  }
}

MagazineTrack.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default MagazineTrack;
